"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryThirdConfig = queryThirdConfig;
exports.setOssConfig = setOssConfig;
exports.showOssConfigDetail = showOssConfigDetail;
exports.thirdConfig = thirdConfig;
var _request = _interopRequireDefault(require("@/utils/request"));
function setOssConfig(data) {
  return (0, _request.default)({
    url: '/portal/system/file/setOssConfig',
    method: 'post',
    data: data
  });
}
function showOssConfigDetail(params) {
  return (0, _request.default)({
    url: '/portal/system/file/showOssConfigDetail',
    method: 'get',
    params: params
  });
}
function queryThirdConfig(params) {
  return (0, _request.default)({
    url: '/portal/system/tenant/queryThirdConfig',
    method: 'get',
    params: params
  });
}
function thirdConfig(data) {
  return (0, _request.default)({
    url: '/portal/system/tenant/thirdConfig',
    method: 'post',
    data: data
  });
}